import React, { memo } from 'react';
import { Panel, PanelHeader, PanelBody } from '../../../components/panel/panel.jsx';
import FormNews from './components/FormNews.js';

import { useLocation } from 'react-router';

const NewsView = () => {
  const location = useLocation();

  return (
    <div>
      <h1 className="page-header">News View</h1>
      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Information</PanelHeader>
            <PanelBody>
              <FormNews action="update" values={location.state} />
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default memo(NewsView);
